module.exports = __webpack_public_path__ + "static/media/Ծիծեռնակ-Մարիետա-Բադալյան.3eefa31a.mp3";